import {
  InputGroup,
  InputRow,
  EmptyInput,
  RadioYesNoInput,
  InputGroupBreak,
  ModelInput,
  AddressSearch,
  ModelPhoneInput,
  flattenErrorTypeArray,
} from '@equifinance/shared';
import { css } from 'styled-components';
import { SectionTitleIcon } from '../../Icons/SectionTitleIcon';
import Section from '../../components/Section';
import { StaticDataItem } from '../../../../api/useAccountApi';
import { useAccountContext } from '../../../../contexts';

const errorContainerCss = css`${({ theme }) => `
  padding: 0 ${theme.padding[4]};
`}`;

export const AdvisorDetailsRefName = 'advisor-details';

export default function AdvisorDetailsSection({
  countries,
}: {
  countries: StaticDataItem[]
}) {
  const { account } = useAccountContext();

  const {
    advisorDetails,
    brokerageName,
    errors,
    warnings,
  } = account;

  const { advisorAddress, wasResponsibleForAdvice } = advisorDetails ?? {};
  const { id: addressId } = advisorAddress ?? {};

  const combinedErrors = [
    ...(errors?.[advisorDetails?.id] ?? []),
    ...(errors?.[advisorDetails?.advisorAddress?.id ?? ''] ?? []),
  ];

  return (
    <Section
      id={advisorDetails?.id}
      refName={AdvisorDetailsRefName}
      titleIcon={<SectionTitleIcon errors={flattenErrorTypeArray(combinedErrors)} />}
      title="Advisor Details"
      errors={errors}
      warnings={warnings}
      errorContainerCss={errorContainerCss}
    >
      <InputGroup>
        <InputRow>
          <RadioYesNoInput
            label={(
              <>
                {`Was ${brokerageName} responsible for the advice the Applicant(s) received in relation to entering into this regulated mortgage contract?`}
              </>
              )}
            field="advisorDetails.wasResponsibleForAdvice"
            required
          />
        </InputRow>
      </InputGroup>

      {wasResponsibleForAdvice === false && (
      <>
        <InputGroupBreak />

        <InputGroup>
          <InputRow>
            <ModelInput
              label={<>FCA registration number</>}
              field="advisorDetails.fcaNumber"
              required
            />
            <ModelInput
              label="Registered company name"
              field="advisorDetails.registeredCompanyName"
              required
            />
          </InputRow>
          <InputRow>
            <ModelPhoneInput
              label="Telephone number"
              field="advisorDetails.telephoneNumber"
              required
            />
            <ModelInput
              label="Email address"
              field="advisorDetails.emailAddress"
              required
            />
          </InputRow>
          <InputRow>
            <ModelInput
              label="Web address"
              field="advisorDetails.webAddress"
            />
            <EmptyInput />
          </InputRow>
        </InputGroup>

        <InputGroupBreak />

        <AddressSearch
          field="advisorDetails.advisorAddress"
          addressId={addressId ?? ''}
          countries={countries?.reduce((prev, current) => ({
            ...prev,
            [current?.key]: current?.label,
          }), {} as Record<string, string>)}
          searchPlaceholder="Enter postcode or first line of trading address"
          subBuildingLabel="Sub-building number"
          buildingNameLabel="Building name"
          buildingNumberLabel="Building number"
          errors={errors}
        />
      </>
      )}

    </Section>
  );
}
